<ng-container *ngIf="spin">
  <div class="d-flex justify-content-center align-items-center text-break text-center">
    <ion-spinner name="circular" color="medium"></ion-spinner>
  </div>
</ng-container>
<ng-container *ngIf="!spin && hasEvaluation()">
  <div class="position-row" *ngFor="let item of positionTypes[photo.type]">
    <form #manualForm="ngForm" (ngSubmit)="_sendManualEvaluation(manualForm)">
      <div class="visit-about-section">
        <h3 class="details-section-title mb-3">{{ 'APP.POSITION.' + item.position | translate }}</h3>
      </div>
      <div class="cont-main">
        <div class="cont-checkbox" *ngFor="let image of item.images; index as j">
          <input type="radio" [name]="item.position" [id]="photo.type + '-' + item.position + '-' + j" [value]="image" [(ngModel)]="modelEvaluationMap[item.position].position" [disabled]="true" />
          <label [for]="photo.type + '-' + item.position + '-' + j">
            <img [src]="'./assets/images/type_position/' + photo.type + '/' + image + '.jpg'" />
            <!-- <span class="cover-checkbox">
              <svg viewBox="0 0 12 10">
                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
              </svg>
            </span> -->
            <span class="cover-ai" *ngIf="aiEvaluationMap[item.position]?.position === (image)">
              <img [src]="'./assets/images/icons/ai.png'">
            </span>
          </label>
        </div>
      </div>
    </form>
  </div>
</ng-container>
